import React from "react";
import AdminLoginSection from "../sections/AdminLogin/AdminLogin";

const AdminLogin = () => {
  return <AdminLoginSection />;
};

export default AdminLogin;

